<script setup lang="ts">
import { storeToRefs } from 'pinia';
import useWordOfTheDayStore from '../store';
import SwedishKeyboard from './SwedishKeyboard.vue';
import Flower from './Flower.vue';
import { useDisplay } from 'vuetify';

const store = useWordOfTheDayStore();
const { word, selectedLetters, gameState, guesses, guessedCorrectWord } = storeToRefs(store);

const { lgAndUp } = useDisplay();
</script>

<template>
  <div class="the-game">
    <h1 class="title">Dagens ord</h1>
    <div class="tries-left">{{ 10 - guesses }} försök kvar</div>

    <Flower class="mt-10 mb-5" />
    <div class="progress ga-4 ga-lg-10">
      <span v-for="(char, index) in word" :key="index" class="progress-letter">
        <span :class="[{ visible: selectedLetters.has(char) }]" class="letter">
          {{ char }}
        </span>
      </span>
    </div>

    <SwedishKeyboard
      v-if="gameState !== 'game-over'"
      @letter-click="(letter: string) => store.makeGuess(letter)"
      class="mb-16 mt-lg-5"
      :guessed-letters="selectedLetters"
      :current-word="word"
      :disabled="gameState !== 'game'"
    />
    <span v-if="gameState === 'game-over'" class="game-over my-lg-10">{{
      guessedCorrectWord ? 'Bra jobbat!' : 'Tyvärr!'
    }}</span>
    <div class="d-flex mt-5 mt-lg-15 mb-8">
      <v-btn
        :height="lgAndUp ? '56px' : '48px'"
        v-if="gameState === 'game-over' && !guessedCorrectWord"
        @click="store.clear"
        variant="outlined"
        color=" white"
        prepend-icon="mdi-repeat"
        text="Prova igen"
        class="mr-4 action-btn"
      ></v-btn>
      <v-btn
        :height="lgAndUp ? '56px' : '48px'"
        v-if="gameState === 'game-over'"
        @click="store.setGameState('results')"
        variant="outlined"
        color=" white"
        append-icon="mdi-chevron-right"
        class="action-btn"
        :text="guessedCorrectWord ? 'Utforska ordet' : 'Se rätt svar'"
      >
      </v-btn>
    </div>
  </div>
</template>

<style scoped lang="scss">
.game-over {
  font-family: 'Chalkduster', sans-serif;
  font-size: clamp(1.5rem, 3vw, 4rem);
}

.progress {
  display: flex;
  justify-content: center;
  margin-top: 20px;
  margin-bottom: 40px;
  color: #fff;
}

.progress-letter {
  font-size: clamp(1.5rem, 3vw, 4rem);
  width: clamp(1rem, 3vw, 4rem);
  height: 5rem;
  display: flex;
  align-items: end;
  justify-content: center;
  border-bottom: 2px solid #fff;
  font-family: 'Chalkduster', sans-serif;

  .letter {
    opacity: 0;
    transition: opacity 0.3s ease-in-out;
    &.visible {
      opacity: 1;
    }
  }
}

.the-game {
  display: flex;
  height: 100%;
  flex-direction: column;
  align-items: center;
  color: #fff;
}

.title {
  position: absolute;
  top: 140px;
  left: 20px;
  transform: rotate(-10deg);
  transform-origin: top left;
  font-size: 2.25rem;
  font-weight: bold;
  font-family: 'Chalkduster', sans-serif;
  color: #fff;
}

.toggle-btn {
  font-family: 'Chalkduster', sans-serif;
  position: absolute;
  top: 100px;
  right: 0;
  display: inline-flex;
  border: 3px solid #2f2f2f;
  font-size: 2.5rem;
  cursor: pointer;
  user-select: none;
  margin-top: 5px;
  margin-right: 10px;
  line-height: 1;
  color: #6f6f6f;
}

.toggle-btn button {
  padding: 10px 20px;
  transition:
    background-color 0.3s,
    color 0.3s;
}

.active {
  color: white;
  border: 3px solid white;
}

.tries-left {
  position: absolute;
  top: calc(64px + 2rem);
  right: 2rem;
  font-size: 1rem;
  font-family: 'Comic Sans MS', sans-serif;
}
</style>
